/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHomeWorkIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-home-work"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M0.17 12.05Q0.17 11.4 0.46 10.84Q0.75 10.28 1.27 9.9L6.38 6.25Q6.72 6 7.11 5.88Q7.5 5.75 7.92 5.75Q8.35 5.75 8.74 5.88Q9.13 6 9.47 6.25L14.57 9.9Q15.1 10.28 15.39 10.84Q15.68 11.4 15.68 12.05L15.68 20.48Q15.68 21.02 15.29 21.41Q14.9 21.8 14.35 21.8L11.38 21.8Q10.82 21.8 10.44 21.41Q10.05 21.02 10.05 20.48L10.05 16.07Q10.05 15.53 9.66 15.14Q9.28 14.75 8.72 14.75L7.13 14.75Q6.58 14.75 6.19 15.14Q5.8 15.53 5.8 16.07L5.8 20.48Q5.8 21.02 5.41 21.41Q5.03 21.8 4.47 21.8L1.5 21.8Q0.95 21.8 0.56 21.41Q0.17 21.02 0.17 20.48ZM23.82 4.8L23.82 19.15Q23.82 20.27 23.06 21.04Q22.3 21.8 21.18 21.8L18.45 21.8Q17.9 21.8 17.51 21.41Q17.13 21.02 17.13 20.48L17.13 10.93Q17.13 10.28 16.84 9.71Q16.55 9.15 16.02 8.78L11 5.17Q10.57 4.88 10.32 4.45Q10.07 4.03 10.07 3.58L10.07 3.58Q10.07 2.85 10.57 2.5Q11.07 2.15 11.72 2.15L21.18 2.15Q22.3 2.15 23.06 2.91Q23.82 3.67 23.82 4.8ZM17.8 9.05L19.13 9.05Q19.4 9.05 19.59 8.85Q19.77 8.65 19.77 8.38L19.77 7.05Q19.77 6.78 19.59 6.59Q19.4 6.4 19.13 6.4L17.8 6.4Q17.52 6.4 17.32 6.59Q17.13 6.78 17.13 7.05L17.13 8.38Q17.13 8.65 17.32 8.85Q17.52 9.05 17.8 9.05ZM17.8 13.3L19.13 13.3Q19.4 13.3 19.59 13.1Q19.77 12.9 19.77 12.63L19.77 11.3Q19.77 11.03 19.59 10.84Q19.4 10.65 19.13 10.65L17.8 10.65Q17.52 10.65 17.32 10.84Q17.13 11.03 17.13 11.3L17.13 12.63Q17.13 12.9 17.32 13.1Q17.52 13.3 17.8 13.3ZM17.8 17.55L19.13 17.55Q19.4 17.55 19.59 17.35Q19.77 17.15 19.77 16.88L19.77 15.55Q19.77 15.28 19.59 15.09Q19.4 14.9 19.13 14.9L17.8 14.9Q17.52 14.9 17.32 15.09Q17.13 15.28 17.13 15.55L17.13 16.88Q17.13 17.15 17.32 17.35Q17.52 17.55 17.8 17.55Z" fill={color} />
    </svg>
  );
}
